import { breakpoints, vars } from '@etg/wings';
import { css } from '@eti/styles';
export const rowItemSize = css`
  display: flex;
  height: 32px;
  justify-content: center;
  width: 32px;
`;
const resetButtonStyles = css`
  appearance: none;
  background-color: transparent;
  border: 0;
  font-family: inherit;
  padding: 0;
  text-align: left;

  html[dir='rtl'] & {
    text-align: right;
  }
`;
export const seatButtonStyles = css`
  cursor: pointer;
  ${resetButtonStyles};
  ${rowItemSize};
  outline: 0;
  position: relative;

  svg {
    height: 100%;
    width: 100%;
  }
`;
const BUTTON_FOCUS_OFFSET = '64px';
export const seatCharacteristicsToggleButtonWrapperStyles = isButtonFocused => css`
  bottom: 0;
  padding-bottom: 90px;
  position: sticky;
  transition: transform 0.3s ease;
  width: 100%;
  z-index: 10;

  @media (max-width: ${breakpoints._768}) {
    transform: translateY(${isButtonFocused ? `-${BUTTON_FOCUS_OFFSET}` : '0'});
  }
`;
export const seatMapFooterStyles = isButtonFocused => css`
  background: ${vars.colors.surface.primary};
  bottom: 0;
  left: 0;
  padding: 8px;
  position: absolute;
  transition: padding-bottom 0.3s ease;
  width: 100%;
  z-index: 1000;

  @media (max-width: ${breakpoints._768}) {
    padding-bottom: ${isButtonFocused ? `calc(${BUTTON_FOCUS_OFFSET} + 8px)` : '8px'};
  }
`;
export const skipButtonWrapperStyles = isButtonFocused => css`
  bottom: 0;
  display: flex;
  height: 48px;
  margin: 8px;
  opacity: ${isButtonFocused ? 1 : 0};
  place-content: center;
  place-items: center;
  pointer-events: none;
  position: fixed;
  right: 0;
  z-index: ${isButtonFocused ? 1001 : 'auto'};

  @media (max-width: ${breakpoints._768}) {
    bottom: -${BUTTON_FOCUS_OFFSET};
    left: 0;
    transform: translateY(${isButtonFocused ? `-${BUTTON_FOCUS_OFFSET}` : '0'});
    transition:
      transform 0.3s ease,
      opacity 0.3s cubic-bezier(0, 0, 0.97, 1);
  }
`;
//# sourceMappingURL=styles.js.map